<template>
    <button
        class="default-btn outlined transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16"
        type="button" data-bs-toggle="modal" data-bs-target="#discard-modal">
        {{ $t('cta.discard') }}
    </button>
    <ConfirmModal id="discard-modal" @confirm="confirm()" :title="$t('cta.$delete.title')" :message="$t('cta.$discard.message')" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ConfirmModal from "@/components/Widgets/ConfirmModal.vue";
export default defineComponent({
    name: "DiscardButton",
    emits: ['confirm'],
    components: {
        ConfirmModal
    },
    methods: {
        confirm() {
            this.$emit('confirm');
        }
    }
});
</script>